export type IContentType = "texts" | "docs" | "defaultContent";
export type ILanguage = "en" | "fi" | "sv" | "de" | "es" | "zh";
export const LANGUAGES: ILanguage[] = ["en", "fi", "sv", "de", "es", "zh"];
export const AI_LANGUAGES: ILanguage[] = ["fi", "sv", "de", "zh"];
export const REFERENCE_LANGUAGE: ILanguage = "en";
export const PAGE_SIZE = 30;
export const LANGUAGE_NAMES = {
    en: "English",
    fi: "Finnish",
    sv: "Swedish",
    de: "German",
    es: "Spanish",
    zh: "Chinese",
};
